import { createApp } from 'vue'
import Logarithm from './Logarithm.vue'
import './assets/global.css'

createApp(Logarithm).mount('#logarithm')
